import React from "react";

import {
  ResponsiveSelect,
  SelectSheetOption,
} from "../../../../components/MobileForm";
import { Pagination } from "../../../../components/Pagination";
import { AdminActivityPageSize } from "../../../../services";
import {
  ACTIVITY_PAGE_SIZE_LABEL,
  ACTIVITY_PAGE_SIZE_OPTIONS,
} from "../constants";
import { PageSizeControl, Pager, PagerGrow } from "../styles";
import { ActivityPagerProps } from "../types";

export const ActivityPager: React.FC<ActivityPagerProps> = ({
  page,
  pageSize,
  shownCount,
  total,
  isCompact,
  onPageChange,
  onPageSizeChange,
}) => {
  const start = page * pageSize;
  const summary = `Showing ${start + 1}–${start + shownCount} of ${total} events`;
  const pageCount = Math.max(1, Math.ceil(total / pageSize));
  const handlePageSizeChange = (option: SelectSheetOption) =>
    onPageSizeChange(Number(option.value) as AdminActivityPageSize);

  return (
    <Pager>
      <PagerGrow>
        <Pagination
          page={page}
          pageCount={pageCount}
          onPageChange={onPageChange}
          ariaLabel="Activity pages"
          summary={summary}
        />
      </PagerGrow>
      <PageSizeControl>
        <span aria-hidden={true}>{ACTIVITY_PAGE_SIZE_LABEL}</span>
        <ResponsiveSelect
          isCompact={isCompact}
          options={ACTIVITY_PAGE_SIZE_OPTIONS}
          value={String(pageSize)}
          onChange={handlePageSizeChange}
          sheetTitle={ACTIVITY_PAGE_SIZE_LABEL}
          testId="activity-page-size"
        />
      </PageSizeControl>
    </Pager>
  );
};
